<!-- 访客管理 -->
<style lang="scss" scoped>
.vistor-manage {
  position: absolute;
  width: 416px;
  top: 135px;
  right: 43px;
  .vistor {
    width: 100%;
    height: 437px;
  }
  .vistor2 {
    margin-top: 20px;
    height: 437px;
  }
}
</style>
<template>
  <div class="vistor-manage common-bg">
    <div class="vistor">
      <today-vistor></today-vistor>
    </div>
    <div class="vistor2">
      <foreign-construction></foreign-construction>
    </div>
  </div>
</template>

<script>
import ForeignConstruction from "./components/foreign-construction.vue";
import todayVistor from "./components/today-vistor.vue";
export default {
  components: { todayVistor, ForeignConstruction },
};
</script>
